import React from 'react';
import PropTypes from 'prop-types';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

import { CONTROL_TEXT, PUBLISHED_BLUE } from '../tokens';
import { IconToggle } from './styles';

/**
 * Bookmarking a public entity is what materializes the private copy: filled
 * removes the private copy, outlined creates it. Render it only where a public
 * copy exists - there is nothing to bookmark otherwise.
 */
export default function BookmarkToggle({ hasPrivateData, onToggle }) {
  return (
    <IconToggle
      type="button"
      onClick={onToggle}
      title={hasPrivateData ? 'In your library - click to remove' : 'Save to your library'}
    >
      {hasPrivateData
        ? <BookmarkIcon sx={{ fontSize: 20, color: PUBLISHED_BLUE }} />
        : <BookmarkBorderIcon sx={{ fontSize: 20, color: CONTROL_TEXT }} />}
    </IconToggle>
  );
}

BookmarkToggle.propTypes = {
  hasPrivateData: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

BookmarkToggle.defaultProps = {
  hasPrivateData: false,
};
